import { createFileRoute } from "@tanstack/react-router"
import { queryClient } from "@/queryClient"
import { getCourseOptions, listAssignmentsOptions, listProjectsOptions } from "@/client/@tanstack/react-query.gen"
import Course from "@/routes/-pages/Course"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

const COURSE_TAB_PARAMS = ["assessments", "grades", "teams"] as const
type CourseTabParam = (typeof COURSE_TAB_PARAMS)[number]

export const Route = createFileRoute("/course/$courseId/")({
  validateSearch: (search: Record<string, unknown>): { tab?: CourseTabParam } => {
    const rawTab = search.tab as string | undefined
    if (rawTab !== undefined && COURSE_TAB_PARAMS.includes(rawTab as CourseTabParam)) {
      return { tab: rawTab as CourseTabParam }
    }
    return { tab: undefined }
  },
  loader: ({ params }) => {
    const { courseId } = params
    return runBackendModePrefetch(() =>
      Promise.all([
        queryClient.prefetchQuery(getCourseOptions({ path: { course_id: courseId } })),
        queryClient.prefetchQuery(listAssignmentsOptions({ path: { course_id: courseId }, query: { page_size: 100 } })),
        queryClient.prefetchQuery(listProjectsOptions({ path: { course_id: courseId } })),
      ]),
    )
  },
  component: Course,
})
